import { GenericForm } from '@neo/blocks/forms/generic-form'
import type { GenericFormType } from '@neo/blocks/forms/types'
import { ScrollArea } from '@neo/primitives/scroll-area'
import { useRef, useState } from 'react'
import type { AgentSettingsFormValues } from '../config/base.config'
import { useAgentSettingsVisibility } from '../hooks/use-agent-settings-visibility'
import { EventCallbackField } from '../sidebar/agent-settings/event-callback-field'
import { useFlowStore } from '../store'

export const EventCallbacksTab = () => {
  const formRef = useRef<GenericFormType<AgentSettingsFormValues>>()
  const agentSettings = useFlowStore((state) => state.agentSettings)
  const [isFormReady, setIsFormReady] = useState(false)
  const { showVoiceSetting, hasSmsNode, hasWhatsappNode } = useAgentSettingsVisibility()

  return (
    <div className="h-full">
      <ScrollArea className="h-full">
        <div className="w-full max-w-3xl overflow-visible pb-6">
          {agentSettings && (
            <GenericForm<AgentSettingsFormValues>
              id="event-callbacks-tab-form"
              fields={[]}
              onMount={(form: GenericFormType<AgentSettingsFormValues>) => {
                formRef.current = form
                setIsFormReady(true)
                useFlowStore.getState().setTabFormInstance('event-callbacks', form)
                return () => useFlowStore.getState().setTabFormInstance('event-callbacks', null)
              }}
              onSubmit={() => {}}
              includeSubmitButton={false}
              defaultValues={agentSettings}
              className="gap-0"
            >
              <div className="flex flex-col gap-5">
                <div className="border-b border-border pb-4">
                  <h2 className="text-p-600 text-foreground">Event callbacks</h2>
                  <p className="mt-1 text-s-400 text-secondary">
                    Configure callback URLs for agent events.
                  </p>
                </div>
                {isFormReady && formRef.current && (
                  <div className="flex flex-col gap-4">
                    {showVoiceSetting && (
                      <>
                        <EventCallbackField
                          label="Hangup URL"
                          form={formRef.current}
                          fieldPath="event_callbacks.HANGUP"
                        />
                        <EventCallbackField
                          label="Recording URL"
                          form={formRef.current}
                          fieldPath="event_callbacks.RECORDING"
                        />
                      </>
                    )}
                    <EventCallbackField
                      label="Error URL"
                      form={formRef.current}
                      fieldPath="event_callbacks.ERROR"
                    />
                    {hasSmsNode && (
                      <EventCallbackField
                        label="SMS Status URL"
                        form={formRef.current}
                        fieldPath="event_callbacks.SMS_STATUS"
                      />
                    )}
                    {hasWhatsappNode && (
                      <EventCallbackField
                        label="WhatsApp Status URL"
                        form={formRef.current}
                        fieldPath="event_callbacks.WHATSAPP_STATUS"
                      />
                    )}
                    {(hasSmsNode || hasWhatsappNode) && (
                      <EventCallbackField
                        label="Conversation Closure URL"
                        form={formRef.current}
                        fieldPath="event_callbacks.CONVERSATION_CLOSURE"
                      />
                    )}
                  </div>
                )}
              </div>
            </GenericForm>
          )}
        </div>
      </ScrollArea>
    </div>
  )
}
